import React, { useEffect, useState } from 'react';
import OldFileErrorPage from './OldFileErrorPage';

const DownloadPage = ({ fileName }) => {
  const [fileLink, setFileLink] = useState(null);
  const [error, setError] = useState(false);

  const getUrl = (endpoint) => {
    return process.env.NODE_ENV === 'development' ? `https://localhost:7065${endpoint}` : endpoint;
  };

  useEffect(() => {
    const fetchFileLink = async () => {
      try {
        const response = await fetch(getUrl(`/api/Resource/GetIFU?fileName=${fileName}`), {
          method: 'GET'
        });
        const data = await response.json();
        if (data.success) {
          setFileLink(data.link);
          const link = document.createElement('a');
          link.href = data.link;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      }
    };

    if (fileName) {
      fetchFileLink();
    }
  }, [fileName]);

  if (error) {
    return <OldFileErrorPage />;
  }
}

export default DownloadPage;